
/* Проверка мобильного браузера */
export let isMobile = { Android: function () { return navigator.userAgent.match(/Android/i); }, BlackBerry: function () { return navigator.userAgent.match(/BlackBerry/i); }, iOS: function () { return navigator.userAgent.match(/iPhone|iPad|iPod/i); }, Opera: function () { return navigator.userAgent.match(/Opera Mini/i); }, Windows: function () { return navigator.userAgent.match(/IEMobile/i); }, any: function () { return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows()); } };
/* Добавление класса touch для HTML если браузер мобильный */
export function addTouchClass() {
  // Добавление класса _touch для HTML если браузер мобильный
  if (isMobile.any()) document.documentElement.classList.add('touch');
}
// Добавление loaded для HTML после полной загрузки страницы
export function addLoadedClass() {
  window.addEventListener("load", function () {
	setTimeout(function () {
	  document.documentElement.classList.add('loaded');
	}, 0);
  });
}
// Получение хеша в адресе сайта
export function getHash() {
  if (location.hash) { return location.hash.replace('#', ''); }
}
// Указание хеша в адресе сайта
export function setHash(hash) {
  hash = hash ? `#${hash}` : window.location.href.split('#')[0];
  history.pushState('', '', hash);
}
// Учет плавающей панели на мобильных устройствах при 100vh
export function fullVHfix() {
  const fullScreens = document.querySelectorAll('[data-fullscreen]');
  if (fullScreens.length && isMobile.any()) {
	window.addEventListener('resize', fixHeight);
	function fixHeight() {
	  let vh = window.innerHeight * 0.01;
	  document.documentElement.style.setProperty('--vh', `${vh}px`);
	}
	fixHeight();
  }
}
// Вспомогательные модули плавного расскрытия и закрытия объекта ======================================================================================================================================================================
export const fnFadeIn = (el, timeout, display = 'block') => {
  el.style.opacity = 0
  el.style.display = display
  el.style.transition = `opacity ${timeout}ms`
  setTimeout(() => {
	el.style.opacity = 1
  }, 10)
}
export const fnFadeOut = (el, timeout) => {
  el.style.opacity = 1
  el.style.transition = `opacity ${timeout}ms`
  el.style.opacity = 0

  setTimeout(() => {
	el.style.display = 'none'
  }, timeout)
}
export const fnSlideUp = (el, duration=500) => {
  el.style.transitionProperty = 'height, margin, padding'
  el.style.transitionDuration = duration + 'ms'
  el.style.boxSizing = 'border-box'
  el.style.height = el.offsetHeight + 'px'
  el.offsetHeight
  el.style.overflow = 'hidden'
  el.style.height = 0
  el.style.paddingTop = 0
  el.style.paddingBottom = 0
  el.style.marginTop = 0
  el.style.marginBottom = 0
  window.setTimeout( () => {
	el.style.display = 'none'
	el.style.removeProperty('height')
	el.style.removeProperty('padding-top')
	el.style.removeProperty('padding-bottom')
	el.style.removeProperty('margin-top')
	el.style.removeProperty('margin-bottom')
	el.style.removeProperty('overflow')
	el.style.removeProperty('transition-duration')
	el.style.removeProperty('transition-property')
  }, duration);
}

export const fnSlideDown = (el, duration=500) => {
  el.style.removeProperty('display');
  let display = window.getComputedStyle(el).display;
  if (display === 'none') display = 'block';
  el.style.display = display;
  let height = el.offsetHeight;
  el.style.overflow = 'hidden';
  el.style.height = 0;
  el.style.paddingTop = 0;
  el.style.paddingBottom = 0;
  el.style.marginTop = 0;
  el.style.marginBottom = 0;
  el.offsetHeight;
  el.style.boxSizing = 'border-box';
  el.style.transitionProperty = "height, margin, padding";
  el.style.transitionDuration = duration + 'ms';
  el.style.height = height + 'px';
  el.style.removeProperty('padding-top');
  el.style.removeProperty('padding-bottom');
  el.style.removeProperty('margin-top');
  el.style.removeProperty('margin-bottom');
  window.setTimeout( () => {
	el.style.removeProperty('height');
	el.style.removeProperty('overflow');
	el.style.removeProperty('transition-duration');
	el.style.removeProperty('transition-property');
  }, duration);
}

export let _slideToggle = (target, duration = 500) => {
  if (target.hidden) {
	return fnSlideDown(target, duration);
  } else {
	return fnSlideUp(target, duration);
  }
}
// Вспомогательные модули блокировки прокрутки и скочка ====================================================================================================================================================================================================================================================================================
export let bodyLockStatus = true;
export let bodyLockToggle = (delay = 500) => {
  if (document.documentElement.classList.contains('lock')) {
	bodyUnlock(delay);
  } else {
	bodyLock(delay);
  }
}
export let bodyUnlock = (delay = 500) => {
  let body = document.querySelector("body");
  if (bodyLockStatus) {
	let lock_padding = document.querySelectorAll("[data-lp]");
	setTimeout(() => {
	  for (let index = 0; index < lock_padding.length; index++) {
		const el = lock_padding[index];
		el.style.paddingRight = '0px';
	  }
	  body.style.paddingRight = '0px';
	  document.documentElement.classList.remove("lock");
	}, delay);
	bodyLockStatus = false;
	setTimeout(function () {
	  bodyLockStatus = true;
	}, delay);
  }
}
export let bodyLock = (delay = 500) => {
  let body = document.querySelector("body");
  if (bodyLockStatus) {
	let lock_padding = document.querySelectorAll("[data-lp]");
	for (let index = 0; index < lock_padding.length; index++) {
	  const el = lock_padding[index];
	  el.style.paddingRight = window.innerWidth - document.querySelector('.wrapper').offsetWidth + 'px';
	}
	body.style.paddingRight = window.innerWidth - document.querySelector('.wrapper').offsetWidth + 'px';
	document.documentElement.classList.add("lock");

	bodyLockStatus = false;
	setTimeout(function () {
	  bodyLockStatus = true;
	}, delay);
  }
}
// Модуль работы со спойлерами =======================================================================================================================================================================================================================
export function spollers() {
  const spollersArray = document.querySelectorAll('[data-spollers]');
  if (spollersArray.length > 0) {
	// Получение обычных слойлеров
	const spollersRegular = Array.from(spollersArray).filter(function (item, index, self) {
	  return !item.dataset.spollers.split(",")[0];
	});
	// Инициализация обычных слойлеров
	if (spollersRegular.length) {
	  initSpollers(spollersRegular);
	}
	// Получение слойлеров с медиа запросами
	let mdQueriesArray = dataMediaQueries(spollersArray, "spollers");
	if (mdQueriesArray && mdQueriesArray.length) {
	  mdQueriesArray.forEach(mdQueriesItem => {
		// Событие
		mdQueriesItem.matchMedia.addEventListener("change", function () {
		  initSpollers(mdQueriesItem.itemsArray, mdQueriesItem.matchMedia);
		});
		initSpollers(mdQueriesItem.itemsArray, mdQueriesItem.matchMedia);
	  });
	}
	// Инициализация
	function initSpollers(spollersArray, matchMedia = false) {
	  spollersArray.forEach(spollersBlock => {
		spollersBlock = matchMedia ? spollersBlock.item : spollersBlock;
		if (matchMedia.matches || !matchMedia) {
		  spollersBlock.classList.add('_spoller-init');
		  initSpollerBody(spollersBlock);
		  spollersBlock.addEventListener("click", setSpollerAction);
		} else {
		  spollersBlock.classList.remove('_spoller-init');
		  initSpollerBody(spollersBlock, false);
		  spollersBlock.removeEventListener("click", setSpollerAction);
		}
	  });
	}
	// Работа с контентом
	function initSpollerBody(spollersBlock, hideSpollerBody = true) {
	  let spollerTitles = spollersBlock.querySelectorAll('[data-spoller]');
	  if (spollerTitles.length) {
		spollerTitles = Array.from(spollerTitles).filter(item => item.closest('[data-spollers]') === spollersBlock);
		spollerTitles.forEach(spollerTitle => {
		  if (hideSpollerBody) {
			spollerTitle.removeAttribute('tabindex');
			if (!spollerTitle.classList.contains('_spoller-active')) {
			  spollerTitle.nextElementSibling.hidden = true;
			}
		  } else {
			spollerTitle.setAttribute('tabindex', '-1');
			spollerTitle.nextElementSibling.hidden = false;
		  }
		});
	  }
	}
	function setSpollerAction(e) {
	  const el = e.target;
	  if (el.closest('[data-spoller]')) {
		const spollerTitle = el.closest('[data-spoller]');
		const spollersBlock = spollerTitle.closest('[data-spollers]');
		const oneSpoller = spollersBlock.hasAttribute('data-one-spoller');
		const spollerSpeed = spollersBlock.dataset.spollersSpeed ? parseInt(spollersBlock.dataset.spollersSpeed) : 500;
		if (!spollersBlock.querySelectorAll('._slide').length) {
		  if (oneSpoller && !spollerTitle.classList.contains('_spoller-active')) {
			hideSpollersBody(spollersBlock);
		  }
		  spollerTitle.classList.toggle('_spoller-active');
		  _slideToggle(spollerTitle.nextElementSibling, spollerSpeed);
		}
		e.preventDefault();
	  }
	}
	function hideSpollersBody(spollersBlock) {
	  const spollerActiveTitle = spollersBlock.querySelector('[data-spoller]._spoller-active');
	  const spollerSpeed = spollersBlock.dataset.spollersSpeed ? parseInt(spollersBlock.dataset.spollersSpeed) : 500;
	  if (spollerActiveTitle && !spollersBlock.querySelectorAll('._slide').length) {
		spollerActiveTitle.classList.remove('_spoller-active');
		_slideUp(spollerActiveTitle.nextElementSibling, spollerSpeed);
	  }
	}
	// Закрытие при клике вне спойлера
	const spollersClose = document.querySelectorAll('[data-spoller-close]');
	if (spollersClose.length) {
	  document.addEventListener("click", function (e) {
		const el = e.target;
		if (!el.closest('[data-spollers]')) {
		  spollersClose.forEach(spollerClose => {
			const spollersBlock = spollerClose.closest('[data-spollers]');
			const spollerSpeed = spollersBlock.dataset.spollersSpeed ? parseInt(spollersBlock.dataset.spollersSpeed) : 500;
			spollerClose.classList.remove('_spoller-active');
			_slideUp(spollerClose.nextElementSibling, spollerSpeed);
		  });
		}
	  });
	}
  }
}
// Модуь работы с табами =======================================================================================================================================================================================================================

export function tabs() {
  const tabs = document.querySelectorAll('[data-tabs]');
  let tabsActiveHash = [];

  if (tabs.length > 0) {
	const hash = getHash();
	if (hash && hash.startsWith('tab-')) {
	  tabsActiveHash = hash.replace('tab-', '').split('-');
	}
	tabs.forEach((tabsBlock, index) => {
	  tabsBlock.classList.add('_tab-init');
	  tabsBlock.setAttribute('data-tabs-index', index);
	  tabsBlock.addEventListener("click", setTabsAction);
	  initTabs(tabsBlock);
	});

  }
  // Установка позиций заголовков
  function setTitlePosition(tabsMediaArray, matchMedia) {
	tabsMediaArray.forEach(tabsMediaItem => {
	  tabsMediaItem = tabsMediaItem.item;
	  let tabsTitles = tabsMediaItem.querySelector('[data-tabs-titles]');
	  let tabsTitleItems = tabsMediaItem.querySelectorAll('[data-tabs-title]');
	  let tabsContent = tabsMediaItem.querySelector('[data-tabs-body]');
	  let tabsContentItems = tabsMediaItem.querySelectorAll('[data-tabs-item]');
	  tabsTitleItems = Array.from(tabsTitleItems).filter(item => item.closest('[data-tabs]') === tabsMediaItem);
	  tabsContentItems = Array.from(tabsContentItems).filter(item => item.closest('[data-tabs]') === tabsMediaItem);
	  tabsContentItems.forEach((tabsContentItem, index) => {
		if (matchMedia.matches) {
		  tabsContent.append(tabsTitleItems[index]);
		  tabsContent.append(tabsContentItem);
		  tabsMediaItem.classList.add('_tab-spoller');
		} else {
		  tabsTitles.append(tabsTitleItems[index]);
		  tabsMediaItem.classList.remove('_tab-spoller');
		}
	  });
	});
  }
  // Работа с контентом
  function initTabs(tabsBlock) {
	let tabsTitles = tabsBlock.querySelectorAll('[data-tabs-titles]>*');
	let tabsContent = tabsBlock.querySelectorAll('[data-tabs-body]>*');
	const tabsBlockIndex = tabsBlock.dataset.tabsIndex;
	const tabsActiveHashBlock = tabsActiveHash[0] == tabsBlockIndex;

	if (tabsActiveHashBlock) {
	  const tabsActiveTitle = tabsBlock.querySelector('[data-tabs-titles]>.tab-active');
	  tabsActiveTitle ? tabsActiveTitle.classList.remove('tab-active') : null;
	}
	if (tabsContent.length) {
	  tabsContent = Array.from(tabsContent).filter(item => item.closest('[data-tabs]') === tabsBlock);
	  tabsTitles = Array.from(tabsTitles).filter(item => item.closest('[data-tabs]') === tabsBlock);
	  tabsContent.forEach((tabsContentItem, index) => {
		tabsTitles[index].setAttribute('data-tabs-title', '');
		tabsContentItem.setAttribute('data-tabs-item', '');

		if (tabsActiveHashBlock && index == tabsActiveHash[1]) {
		  tabsTitles[index].classList.add('tab-active');
		}
		tabsContentItem.hidden = !tabsTitles[index].classList.contains('tab-active');
	  });
	}
  }
  function setTabsStatus(tabsBlock) {
	let tabsTitles = tabsBlock.querySelectorAll('[data-tabs-title]');
	let tabsContent = tabsBlock.querySelectorAll('[data-tabs-item]');
	const tabsBlockIndex = tabsBlock.dataset.tabsIndex;
	function isTabsAnamate(tabsBlock) {
	  if (tabsBlock.hasAttribute('data-tabs-animate')) {
		return tabsBlock.dataset.tabsAnimate > 0 ? Number(tabsBlock.dataset.tabsAnimate) : 500;
	  }
	}
	const tabsBlockAnimate = isTabsAnamate(tabsBlock);
	if (tabsContent.length > 0) {
	  const isHash = tabsBlock.hasAttribute('data-tabs-hash');
	  tabsContent = Array.from(tabsContent).filter(item => item.closest('[data-tabs]') === tabsBlock);
	  tabsTitles = Array.from(tabsTitles).filter(item => item.closest('[data-tabs]') === tabsBlock);
	  tabsContent.forEach((tabsContentItem, index) => {
		if (tabsTitles[index].classList.contains('tab-active')) {
		  if (tabsBlockAnimate) {
			_slideDown(tabsContentItem, tabsBlockAnimate);
		  } else {
			tabsContentItem.hidden = false;
		  }
		  if (isHash && !tabsContentItem.closest('.popup')) {
			setHash(`tab-${tabsBlockIndex}-${index}`);
		  }
		} else {
		  if (tabsBlockAnimate) {
			_slideUp(tabsContentItem, tabsBlockAnimate);
		  } else {
			tabsContentItem.hidden = true;
		  }
		}
	  });
	}
  }
  function setTabsAction(e) {
	const el = e.target;
	if (el.closest('[data-tabs-title]')) {
	  const tabTitle = el.closest('[data-tabs-title]');
	  const tabsBlock = tabTitle.closest('[data-tabs]');
	  if (!tabTitle.classList.contains('tab-active') && !tabsBlock.querySelector('._slide')) {
		let tabActiveTitle = tabsBlock.querySelectorAll('[data-tabs-title].tab-active');
		tabActiveTitle.length ? tabActiveTitle = Array.from(tabActiveTitle).filter(item => item.closest('[data-tabs]') === tabsBlock) : null;
		tabActiveTitle.length ? tabActiveTitle[0].classList.remove('tab-active') : null;
		tabTitle.classList.add('tab-active');
		setTabsStatus(tabsBlock);
	  }
	  e.preventDefault();
	}
  }
}

// Форматирование цифр типа 100 000 000
export function getDigFormat(item) {
  return item.toString().replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, "$1 ");
}
